import type { FloristInfo } from '~/app/types/florist/floristInfoType';
import { emptyFloristInfo } from '~/app/types/florist/floristInfoType';
import type { UserInfo } from '~/composables/fetchFloristInfo';
import { emptyUserInfo } from '~/composables/fetchFloristInfo';

const SHOP_OWNER = 'SHOP_OWNER';

export const useFloristInfoStore = defineStore('floristInfo', () => {
  // STATE
  const floristInfo = ref(emptyFloristInfo);
  const adminLogin = ref('');
  const isInternalUser = ref(false);
  const isDeliveryMan = ref(false);
  const deliveryManId = ref('');
  const deliveryManInfo = ref<UserInfo>(emptyUserInfo);
  const basic = ref('');

  // STATE MANIPULATION
  function setFloristInfo(data: FloristInfo) {
    floristInfo.value = data;
  }

  function setAdminLogin(data: string) {
    adminLogin.value = data;
  }

  function setIsInternalUser(_isInternalUser: boolean) {
    isInternalUser.value = _isInternalUser;
  }

  function setIsDeliveryMan(_isDeliveryMan: boolean) {
    isDeliveryMan.value = _isDeliveryMan;
  }

  function setDeliveryManId(_deliveryManId: string) {
    deliveryManId.value = _deliveryManId;
  }

  function setDeliveryManInfo(_deliveryManInfo: UserInfo) {
    deliveryManInfo.value = _deliveryManInfo;
  }

  function setBasic(data: string) {
    basic.value = data;
  }

  // ACTIONS
  function clearFloristInfo() {
    setFloristInfo(emptyFloristInfo);
    setAdminLogin('');
    setIsInternalUser(false);
    setBasic('');
  }

  // GETTERs
  const isFloristIsManager = computed(() => {
    floristInfo.value.users.forEach((user) => {
      if (user.role === SHOP_OWNER) {
        return true;
      }
    });
    return false;
  });

  const isFloristUnauthorized = computed(() => {
    return !!(floristInfo.value.floristActivity.deleted || floristInfo.value.floristActivity.suspended);
  });

  return {
    floristInfo,
    adminLogin,
    isInternalUser,
    isDeliveryMan,
    deliveryManId,
    deliveryManInfo,
    setFloristInfo,
    setAdminLogin,
    setIsInternalUser,
    setIsDeliveryMan,
    setDeliveryManId,
    setDeliveryManInfo,
    isFloristIsManager,
    clearFloristInfo,
    isFloristUnauthorized,
    basic,
  };
});
